import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ColumnConfiguration} from 'nav/expanded/ListingRendererConstants';
import {FilterKey, ListableItem} from 'search/SearchConstants';

export enum SearchPluginColumnPosition {
  FIRST = 0,
  BEFORE_LISTING_RENDERER = 10,
  // Do not use this option - it only exists to provide a reference point for the weights.
  LISTING_RENDERER = 20,
  AFTER_LISTING_RENDERER = 30,
}

export interface SearchPlugin {
  pluginApplies: (modelType: ModelTypeConstants) => boolean;
  supportedFilters: Array<FilterKey>;
  getColumnConfigurations(
    items: Array<ListableItem>,
    extras: unknown
  ): Array<ColumnConfiguration<ListableItem>>;
  getRowContentHeight(item: ListableItem, extras: unknown): number;
  columnPosition: SearchPluginColumnPosition;
}
